<div class="title_div">
    <div class="w-100 d-flex justify-content-between align-items-center">
      <div class="title_sub_div_1 title_right_icon_div">Analysis</div>
      <div class="title_sub_div_1 mt-1 mr-1">
        <i class="fa fa-home" (click)="home()" title="Dashboard"></i> <!-- Home icon here -->
      </div>
    </div>
  </div>
<div class="chart-wrapper">
    <!-- Bar Chart -->
    <div class="chart-container" *ngIf="showBarChart">
      <canvas
        baseChart
        [datasets]="barChartData.datasets"
        [labels]="barChartData.labels"
        [options]="chartOptions"
        [legend]="chartLegend"
        [chartType]="barChartType"
      ></canvas>
    </div>
  
    <!-- Doughnut Chart -->
    <div class="chart-container" *ngIf="showDoughnutChart">
      <canvas
        baseChart
        [datasets]="doughnutChartData.datasets"
        [labels]="doughnutChartData.labels"
        [options]="chartOptions"
        [legend]="chartLegend"
        [chartType]="doughnutChartType"
      ></canvas>
    </div>
  
    <!-- Pie Chart -->
    <div class="chart-container" *ngIf="showPieChart">
      <canvas
        baseChart
        [datasets]="pieChartData.datasets"
        [labels]="pieChartData.labels"
        [options]="chartOptions"
        [legend]="chartLegend"
        [chartType]="pieChartType"
      ></canvas>
    </div>
  
    <!-- Polar Area Chart -->
    <div class="chart-container" *ngIf="showPolarAreaChart">
      <canvas
        baseChart
        [datasets]="polarAreaChartData.datasets"
        [labels]="polarAreaChartData.labels"
        [options]="chartOptions"
        [legend]="chartLegend"
        [chartType]="polarAreaChartType"
      ></canvas>
    </div>
  </div>
  